<div class="modal-header py-2">
  <h2 *ngIf="title" class="mb-0">{{title}}</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>
<div class="modal-body">
  <form *ngIf="party && resourcesForm" role="form" [formGroup]="resourcesForm" (ngSubmit)="saveAndMarkSeated()" novalidate>
    <div class="row" formGroupName="assignList">
      <!-- services -->
      <div *ngIf="services?.length"
          class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">{{location.serviceSettings?.label || 'service'}}</label>
        <frontend-dropdown
          elementId="input-modal-service"
          [items]="services"
          [multiple]="true"
          [clearable]="true"
          bindLabel="name"
          bindValue="_id"
          clearAllText="Clear"
          name="services"
          formControlName="services"
        ></frontend-dropdown>
      </div>

       <!-- resources -->
       <div *ngIf="resources?.length"
            class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">{{location.resourceSettings?.label || 'resource'}}</label>
        <frontend-dropdown
          elementId="input-modal-resource"
          [items]="resources"
          [multiple]="true"
          [clearable]="true"
          bindLabel="name"
          bindValue="_id"
          clearAllText="Clear"
          name="resources"
          formControlName="resources"
          [customOptionHtml]="getResourceTextWithSize"
          [customName]="getResourceText"
        ></frontend-dropdown>
      </div>
    </div>
    <div  formGroupName="overrideResources">
      <div *ngIf="servicesWarning"
          class="alert alert-warning"
          role="alert">
      Sorry, no services available at this time.
      </div>
      <div *ngIf="formErrors?.resourcesSizeError" class="alert alert-warning" role="alert">
        Sorry, the {{location.displayOptions?.labels?.customer || 'customer'}} size
        is {{formErrors?.resourcesSizeError?.deltaResourcesSize}}
        {{formErrors?.resourcesSizeError?.determiner}} than the {{location.resourceSettings?.label || "resource"}} capacity.
        Please add another
        {{location.resourceSettings?.label || "resource"}} or {{formErrors?.resourcesSizeError?.determinerChange}}
        the {{location.displayOptions?.labels?.customer || 'customer'}} size.
          <label class="form-check-label pl-0 d-flex">
            <strong>Override?</strong>
            <input type="checkbox"
                    class="ml-2"
                    name="overrideBySize"
                    formControlName="overrideBySize">
          </label>
      </div>
      <div *ngIf="formErrors?.resourcesAvailabilityError"
            class="alert alert-warning d-flex justify-content-between"
            role="alert">
        Sorry, we don't have an available {{location.resourceSettings?.label || 'resource'}} at this time.
        <label class="form-check-label pl-0 d-flex">
          <strong>Override?</strong>
          <input type="checkbox"
                  class="ml-2"
                  name="overrideByResources"
                  formControlName="overrideByResources">
        </label>
      </div>
      <div *ngIf="formErrors?.isOutOfScheduleError"
            class="alert alert-warning" role="alert">
        Sorry, the start or end time is outside your configured business hours, or it's in the past.
        <label class="form-check-label pl-0 d-flex">
          <strong>Override?</strong>
          <input type="checkbox"
                  class="ml-2"
                  name="overrideByWorkHours"
                  formControlName="overrideByWorkHours">
        </label>
      </div>
      <div *ngIf="formErrors?.overlapError" class="alert alert-warning" role="alert">
        Sorry, this {{location.displayOptions?.labels?.reservation || 'reservation'}} overlaps with another.
        Available duration is {{formErrors?.overlapError?.availablePartyDurationInMin}} min
        <div class="link" (click)="setAvailableDuration()">Set duration to available time?</div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit"
              [disabled]="checkInvalid()"
              class="btn btn-info"
              angularticsCategory="waitlist"
              angulartics2On="click"
              id="confirm-add-edit-party-button"
              angularticsAction="served and assigned resource to party">Confirm
      </button>
      <button type="button" class="btn btn-danger" (click)="cancel()">Cancel
      </button>
    </div>
  </form>
</div>
